import React, { useEffect } from "react";
import type { FC } from "react";
import type { IHiddenControlProps } from "./HiddenControl.types";
import { useBulkExportContext } from "../../../../providers";

/** This control implicitly selects all elements of the dimension */
export const HiddenControl: FC<IHiddenControlProps> = (props) => {
  const { hierarchyIdentifier, items } = props;
  const context = useBulkExportContext();
  const contextDimensions = context?.state.dimensions;
  const setDimensions = context?.actions.setDimension;

  useEffect(() => {
    let currentContextDimension = contextDimensions?.find((x) => x.id === hierarchyIdentifier);
    const hasSelect = Boolean(currentContextDimension?.selection.length);
    const hasCandidates = Boolean(items.length);
    if (!hasSelect && hasCandidates) {
      const selectCandidate = items.map((it) => it.id);
      currentContextDimension = currentContextDimension ?? {
        id: hierarchyIdentifier,
        isSelected: true,
        selection: selectCandidate,
        fieldName: "",
      };
      (currentContextDimension.selection = selectCandidate), setDimensions?.(currentContextDimension);
    }
  }, [hierarchyIdentifier, items, contextDimensions, setDimensions]);

  return null;
};
